<template>
    <div>
        <template v-if="organization.applications.length > 0">
            <label class="mb-1">{{ $t('organization_details.organization_documents') }}</label>
            <div v-if="userAdminsOrganization" class="flex flex-col">
                <div class="card input-border-color last:mb-0 mb-3">
                    <div class="card-body lg:px-4 px-3">
                        <div class="flex flex-row items-center">
                            <div class="lg:mr-4 flex-1 mr-3">
                                <h4 class="mt-0 mb-1 text-base">{{ $t('organization_details.contract_details') }}</h4>
                                <div class="text-xs">
                                    {{ $t('organization_details.accepted_on_date', { date: formatDate(organization.created_at) }) }}
                                </div>
                            </div>
                            <a :href="`/organization/details/download-contract`" class="btn btn-primary btn-sm lg:mr-2 mr-1">
                                <span class="mr-1">{{ $t('globals.download') }}</span>
                                <span class="icon icon-download"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="border-warning-500 w-full p-4 mb-6 bg-gray-200 border-l-4 rounded shadow" role="alert">
                <p class="mb-0">{{ $t('organization_details.organization_documents_unavailable') }}</p>
            </div>
        </template>
    </div>
</template>

<script>
import { lightFormat, parseISO } from 'date-fns';

export default {
    props: {
        organization: {
            type: Object,
            required: true,
        },
    },

    computed: {
        userAdminsOrganization() {
            return window.Globals.user.is_admin || window.Globals.user.organization.owner_id === window.Globals.user.id;
        },
    },

    methods: {
        formatDate(date) {
            return lightFormat(parseISO(date), 'dd-MM-y');
        },
    },
};
</script>
